import * as React from "react";
import PropTypes from "prop-types";

const RiverDetails = ({ details }) => {
  let display = [];

  if (details.miles) {
    display.push(details.miles + " miles");
  }
  if (details.difficulty) {
    display.push(details.difficulty + " difficulty");
  }
  if (details.season) {
    display.push("Season: " + details.season);
  }
  if (details.reclevel) {
    display.push(details.reclevel + " Rec Level");
  }
  if (details.permits) {
    display.push("Permit: " + details.permits);
  }

  if (details.putin && details.takeout) {
    display.push("Put In: " + details.putin + ", Takeout: " + details.takeout);
  } else {
    if (details.putin) {
      display.push("Put In: " + details.putin);
    }
    if (details.takeout) {
      display.push("Takeout: " + details.takeout);
    }
  }
  return <>{display.join(" / ")}</>;
};

RiverDetails.propTypes = {
  details: PropTypes.object,
};

export default RiverDetails;
